module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-light-gray@3x-5aa98a46a56543743660179258daf276.png";